import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { SubmitFeedbackRequest, SubmitFeedbackResponse, UserFeedback } from '@/api/types';

export function useUserFeedback(limit = 10) {
    return useQuery<UserFeedback[]>({
        queryKey: ['feedback', 'user', limit],
        queryFn: () => api.get(`/api/feedback?limit=${limit}`),
    });
}

export function useSubmitFeedback() {
    const queryClient = useQueryClient();

    return useMutation<SubmitFeedbackResponse, Error, SubmitFeedbackRequest>({
        mutationFn: (data) => api.post('/api/feedback', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['feedback', 'user'] });
        },
    });
}
